import { Component } from '@angular/core';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.css']
})
export class PageFooterComponent {

  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true

  // Footer Varient Class
  footerOne = 'bg-dark'
  footerTwo = 'footer-two'
  footerThree = 'footer-three'
  footerFour = 'footer-four'
  footerFive = 'footer-five'
  footerSix = 'bg-light'
  footerSeven = 'footer-seven'
  footerEight = 'footer-eight'
  footerNine = 'footer-nine'
  footerTen = 'footer-ten'

}
